import React, { Fragment, useEffect, useState } from 'react'
import {
  Box,
  Button,
  Grid,
  IconButton,
  LinearProgress,
  List,
  Tooltip,
  Typography,
  
  Link,
  ListItemText,
  CircularProgress,
  FormControlLabel,
  FormControl,
  Radio,
  RadioGroup,
  ListItem,
  ListItemAvatar,
  Avatar
} from '@mui/material'
import { withStyles } from '@mui/styles'
import { apiCall, ApiConfig } from '../../../config/api'
import { SnackBar } from '../../SnackBar/Snackbar'
import { ApiResponse } from '../../../models/ApiResponse'
import axios from 'axios'
import HelpIcon from '@mui/icons-material/Help'
import { templateMassiveProcessInventory } from '../../../const/templatesFileName'
import { Selector } from '../../Selector'
import { useWarehouses, useZones } from '../../../hooks'
import { Zone } from '../../../interfaces'
import { Info } from '@mui/icons-material'

/*
Copyright 2022-07-12 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Agrega selección warehouse al crear WorkOrder por archivo.
*/

enum eTypeLoad {
  'byWarehouse' = 1,
  'byZone' = 2
}

const BorderLinearProgress = withStyles(() => ({
  root: {
    height: 15,
    borderRadius: 5
  },
  colorPrimary: {
    backgroundColor: '#EEEEEE'
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#1a90ff'
  }
}))(LinearProgress)

class SnackBarStatus {
  isOpen: boolean = false
  message: string = ''
  status: string = ''
}

interface UploadOrderFileProps {}

export const UploadOrderFile: React.FC<UploadOrderFileProps> = () => {
  const {
    zonesState: { zones }
  } = useZones()

  const {
    warehousesState: { warehouses },
    getWarehouses
  } = useWarehouses()

  useEffect(() => {
    if (warehouses?.length === 0) {
      getWarehouses()
    } else if (warehouses?.length === 1) {
      setSelectedWarehouse(warehouses[0].id)
    }
  }, [warehouses])

  const maxFileSize = 2097152
  const [isUploading, setIsUploading] = useState<boolean>(false)
  const [selectedFiles, setSelectedFiles] = useState<any[] | undefined>(
    undefined
  )
  const [currentFile, setCurrentFile] = useState<any | undefined>(undefined)
  const [progress, setProgress] = useState<number>(0)
  const [snackBarStatus, setSnackBarStatus] = useState<SnackBarStatus>(
    new SnackBarStatus()
  )
  const [disabledLink, setDisabledLink] = useState<boolean>(false)

  const [selectedWarehouse, setSelectedWarehouse] = useState<number>(-1)
  const [zonesByWarehouse, setZonesByWarehouse] = useState<Zone[]>([])
  const [selectedZone, setSelectedZone] = useState<number>(-1)
  const [showZone, setShowZone] = useState<string>('byWarehouse')

  const handleSelectedWarehouseZones = (zones: Zone[]) => {
    if (selectedWarehouse > 0) {
      const initialZones = [...zones!]

      const filteredZones = initialZones.filter(
        (x: Zone) => x.warehouseId === selectedWarehouse
      )

      setZonesByWarehouse(filteredZones)

      if (filteredZones.filter((x) => x.zoneId === selectedZone).length === 0) {
        setSelectedZone(-1)
      }
    } else {
      setSelectedWarehouse(-1)
      setSelectedZone(-1)
      setZonesByWarehouse([])
    }
  }

  useEffect(() => {
    handleSelectedWarehouseZones(zones!)
  }, [selectedWarehouse, showZone])

  const notify = (message: string, status: string) => {
    const newStatus: SnackBarStatus = {
      isOpen: true,
      message: message,
      status: status
    }
    setSnackBarStatus(newStatus)
  }

  const handleSnackbar = (isOpen: boolean) => {
    setSnackBarStatus({ ...snackBarStatus, isOpen: isOpen })
  }

  const handleSelectFile = (event: any) => {
    setSelectedFiles(event.target.files)
    setProgress(0)
    setSnackBarStatus(new SnackBarStatus())
  }

  const sizeLabel = (size: number): string => {
    let label = ''
    if (size / 1024 / 1024 > 1) label = (size / 1024 / 1024).toFixed(2) + ' MB'
    else if (size / 1024 > 1) label = (size / 1024).toFixed(0) + ' KB'
    else label = size.toFixed(2) + ' Bytes'
    return label
  }

  const validateFile = (files: any[] | undefined): string => {
    if (!files || files.length === 0) {
      return 'Ningún archivo seleccionado'
    }

    const selectedFile = files[0]

    if (selectedFile.size > maxFileSize) {
      const maxLabel = sizeLabel(maxFileSize)
      return `El archivo seleccionado supera el tamaño máximo: ${maxLabel}`
    }

    if (selectedFile.name.toLowerCase().indexOf('.xls') < 0) {
      return `El archivo seleccionado no es de tipo Excel (.xls)`
    }

    return ''
  }

  const getTypeLoad = () => {
    if (showZone === eTypeLoad[eTypeLoad.byWarehouse]) {
      return eTypeLoad.byWarehouse
    }

    return eTypeLoad.byZone
  }

  const callUpload = (file: any, onUploadProgress: (event: any) => void) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('warehouseId', `${selectedWarehouse}`)
    formData.append('zoneId', `${selectedZone}`)
    formData.append('typeLoad', `${getTypeLoad()}`)

    const axiosInstance = axios.create({
      baseURL: ApiConfig.ProcessApi,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return axiosInstance.post(`/InventoryUploadFile`, formData, {
      onUploadProgress
    })
  }

  const handleUpload = () => {
    const validateError = validateFile(selectedFiles)
    if (validateError !== '') {
      setCurrentFile(undefined)
      notify(validateError, 'error')
      return
    }

    if (!selectedFiles) return

    const selectedFile = selectedFiles[0]
    setProgress(0)
    setCurrentFile(selectedFile)
    setIsUploading(true)

    callUpload(selectedFile, (event) => {
      setProgress(Math.round((100 * event.loaded) / event.total))
    })
      .then((response) => {
        const apiResponse = response.data as ApiResponse
        setIsUploading(false)
        if (apiResponse.success) {
          notify('El archivo ha sido cargado para su procesamiento', 'success')
        } else {
          notify(
            `Error en carga de archivo: ${
              apiResponse.message || 'falla en el servicio.'
            }`,
            'error'
          )
        }
        setCurrentFile(undefined)
        setSelectedFiles(undefined)
        setProgress(0)
      })
      .catch((error) => {
        setIsUploading(false)
        setProgress(0)
        notify(
          `Error en carga de archivo: ${
            error.response?.data?.message || 'falla en el servicio.'
          }`,
          'error'
        )
        setCurrentFile(undefined)
        setSelectedFiles(undefined)
        setProgress(0)
      })
  }

  const handleDownloadTemplate = () => {
    setDisabledLink(true)
    setTimeout(() => {
      apiCall(
        'GET',
        `${ApiConfig.ProcessApi}/GetTemplateFile/${templateMassiveProcessInventory}`,
        {
          responseType: 'blob'
        }
      )
        .then((response: any) => {
          if (response.status === 200 && response.data !== null) {
            const raw = window.atob(response.data.file)
            const uInt8Array = new Uint8Array(raw.length)
            for (let i = 0; i < raw.length; ++i) {
              uInt8Array[i] = raw.charCodeAt(i)
            }
            const link = document.createElement('a')
            const blob = new Blob([uInt8Array], {
              type: response.data.mimeType
            })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', response.data.name)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        })
        .catch((message: any) => {
          console.log('message: ', message)
        })
      setDisabledLink(false)
    }, 1500)
  }

  React.useEffect(() => {
    if (warehouses?.length === 1) {
      setSelectedWarehouse(warehouses[0].id)
    }
  }, [warehouses])

  const handleSetWarehouse = (id: number) => {
    setSelectedWarehouse(id)
  }

  const handleSetZone = (id: number) => {
    setSelectedZone(id)
  }

  const handleSetShowZone = (event: React.ChangeEvent<HTMLInputElement>) => {
    setShowZone((event.target as HTMLInputElement).value)
    setSelectedZone(-1)
    setZonesByWarehouse([])
  }

  const validateButtonLoad = () => {
    if (
      showZone === 'byZone' &&
      (selectedWarehouse <= 0 ||
        !selectedFiles ||
        isUploading ||
        selectedZone <= 0)
    ) {
      return true
    } else {
      if (
        showZone === 'byWarehouse' &&
        (selectedWarehouse <= 0 || !selectedFiles || isUploading)
      ) {
        return true
      } else {
        return false
      }
    }
  }

  return (
    <Fragment>
      <Grid container spacing={4} direction='column' alignItems='center'>
        <Typography variant='h4' component='h4'>
          Cargar Inventario por Almacén
        </Typography>

        <Grid item xs={12} style={{ padding: '0px' }}>
          <List style={{ width: '100%' }}>
            <ListItem alignItems='flex-start'>
              <ListItemAvatar>
                <Avatar>
                  <Info />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography variant='h6' component='h6' gutterBottom>
                    IMPORTANTE: Recuerde que se <b>eliminará</b> todo el stock
                    de las posiciones de la(s) zona(s) o <b>almacén</b> elegido
                    y se reemplazará por el contenido en el archivo. Esta acción{' '}
                    <b>no</b> es posible de revertir.
                  </Typography>
                }
                secondary={
                  <React.Fragment>
                    <Box>
                      <Typography
                        component='ol'
                        style={{ listStyle: 'square' }}
                      >
                        <Typography
                          variant='subtitle1'
                          component='li'
                          gutterBottom
                        >
                          Si existe un <b>error</b> en el archivo, toda la carga
                          se <b>invalidará</b>, favor revise el estado de esta
                          en el menú procesos.
                        </Typography>
                        <Typography
                          variant='subtitle1'
                          component='li'
                          gutterBottom
                        >
                          Sólo se actualizarán posiciones de <b>venta</b> o{' '}
                          <b>reposición</b>.
                        </Typography>
                        <Typography
                          variant='subtitle1'
                          component='li'
                          gutterBottom
                        >
                          Se recomienda que la operación no tenga{' '}
                          <b>rutas de picking</b> en proceso o sin concluir.
                        </Typography>
                        <Typography
                          variant='subtitle1'
                          component='li'
                          gutterBottom
                        >
                          Se recomienda que la operación no tenga{' '}
                          <b>Asn(s)</b> en proceso o sin concluir.
                        </Typography>
                        <Typography
                          variant='subtitle1'
                          component='li'
                          gutterBottom
                        >
                          Si elige inventario por <b>zona</b>, sólo se cargará
                          el inventario a la zona seleccionada, las demás zonas
                          permanecerán con el stock actual.
                        </Typography>
                        <Typography
                          variant='subtitle1'
                          component='li'
                          gutterBottom
                        >
                          Puede descargar una <b>plantilla</b> desde el link que
                          se encuentra disponible a continuación.
                          <br />
                          {disabledLink ? (
                            <Fragment>
                              <Link
                                style={{
                                  cursor: 'pointer',
                                  pointerEvents: 'none'
                                }}
                                onClick={handleDownloadTemplate}
                              >
                                Descargando Plantilla...
                              </Link>{' '}
                              <CircularProgress size='0.9rem' />
                            </Fragment>
                          ) : (
                            <Link
                              style={{ cursor: 'pointer' }}
                              onClick={handleDownloadTemplate}
                            >
                              Descargar Plantilla
                            </Link>
                          )}
                        </Typography>
                      </Typography>
                    </Box>
                  </React.Fragment>
                }
              />
            </ListItem>
          </List>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={12} style={{ textAlign: 'center' }}>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby='demo-row-radio-buttons-group-label'
            name='row-radio-buttons-group'
            onChange={handleSetShowZone}
            value={showZone}
          >
            <FormControlLabel
              value='byWarehouse'
              control={<Radio />}
              label='Por Almacén'
            />
            <FormControlLabel
              value='byZone'
              control={<Radio />}
              label='Por Zona'
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid
        item
        xs={12}
        justifyContent='center'
        alignItems='center'
        alignContent='center'
        style={{ textAlign: 'center' }}
      >
        <FormControl>
          <Selector
            labelId='selectedWarehouse'
            item={
              warehouses &&
              warehouses.map((item) => ({
                value: item.id,
                name: item.warehouseName
              }))
            }
            defaultLabel='Almacén'
            onChange={(e: any) => handleSetWarehouse(e.target.value as number)}
            id='warehouseId'
            name='warehouseId'
            value={selectedWarehouse}
            variant='outlined'
          />
        </FormControl>
      </Grid>

      <Grid
        item
        xs={12}
        justifyContent='center'
        alignItems='center'
        alignContent='center'
        style={{ textAlign: 'center', padding: 10 }}
      >
        {showZone === 'byZone' ? (
          <FormControl>
            <Selector
              labelId='selectedPicker'
              item={
                zonesByWarehouse &&
                zonesByWarehouse.map(({ zoneId, zoneName }: Zone) => {
                  return {
                    value: zoneId,
                    name: zoneName
                  }
                })
              }
              defaultLabel='Zona'
              onChange={(e: any) => handleSetZone(e.target.value as number)}
              id='zoneId'
              name='zoneId'
              value={selectedZone}
              fullWidth
              variant='outlined'
            />
          </FormControl>
        ) : (
          // Espacio vacío para mantener la altura del formulario al no mostrarse el control. (para que los botones de abajo no suban y bajen)
          <Box style={{ height: '56px' }} />
        )}
      </Grid>

      <Box className='mb25' display='flex' alignItems='center'>
        <Grid
          container
          spacing={4}
          direction='row'
          alignItems='center'
          justifyContent='center'
          style={{ justifyContent: 'center' }}
        >
          <Grid item xs={3} style={{ textAlign: 'right' }}>
            <label htmlFor='btn-upload'>
              <input
                id='btn-upload'
                name='btn-upload'
                style={{ display: 'none' }}
                type='file'
                onChange={handleSelectFile}
                accept='.xls,.xlsx'
              />
              <Tooltip
                title='Seleccionar el archivo Excel a cargar'
                placement='top-end'
              >
                <Button
                  className='btn-choose'
                  variant='outlined'
                  component='span'
                >
                  Seleccionar Archivo
                </Button>
              </Tooltip>
            </label>
          </Grid>

          <Grid item xs={5}>
            <div className='file-name'>
              {selectedFiles && selectedFiles.length > 0
                ? selectedFiles[0].name
                : null}
            </div>
          </Grid>

          <Grid item xs={1}>
            <Tooltip
              title='Enviar el archivo seleccionado al servidor para su procesamiento'
              placement='top-end'
            >
              <Button
                className='btn-upload'
                color='primary'
                variant='contained'
                component='span'
                disabled={validateButtonLoad()}
                onClick={handleUpload}
              >
                Cargar
              </Button>
            </Tooltip>
          </Grid>

          <Grid
            item
            xs={1}
            alignContent='center'
            style={{ textIndent: '15px' }}
          >
            <Tooltip
              title='Oprima el botón SELECCIONAR para abrir el archivo a cargar y luego el botón CARGAR para enviar el archivo al servidor para su procesamiento'
              placement='top-end'
            >
              <IconButton>
                <HelpIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Box>

      <div
        style={{
          margin: '10px',
          visibility: currentFile ? 'visible' : 'hidden'
        }}
      >
        <BorderLinearProgress variant='determinate' value={progress} />

        <Box minWidth={35}>
          <Typography
            variant='body1'
            color='textSecondary'
            style={{ textAlign: 'end' }}
          >{`${progress}%`}</Typography>
        </Box>
      </div>

      <SnackBar
        open={snackBarStatus.isOpen}
        setOpen={handleSnackbar}
        message={snackBarStatus.message}
        status={snackBarStatus.status}
      ></SnackBar>
    </Fragment>
  )
}
